export const UI_FACET_CATEGORY = 'category';
export const PAGE_SIZE = 20;
export const DEFAULT_RECALLS_SORTING = { sort: 'date', order: 'desc' };

export const SEARCH_FACETS = {
  WHERE_MADE: 'country-were-made',
  WHERE_RECALLED: 'country-were-recalled',
  GPC_SEGMENT: 'gs1-gpc-segment',
  GPC_FAMILY: 'gs1-gpc-family',
  GPC_CLASS: 'gs1-gpc-class',
  GPC_BRICK: 'gs1-gpc-brick',
  CONCEPT_FROM_QUERY: 'concepts-from-query',
  BEST_TAGS: 'best-tags',
  RELATED_CONCEPTS: 'related-concepts',
};

export const CATEGORY_SEARCH_FACETS = [
  SEARCH_FACETS.GPC_SEGMENT,
  SEARCH_FACETS.GPC_FAMILY,
  SEARCH_FACETS.GPC_CLASS,
  SEARCH_FACETS.GPC_BRICK,
];

export const CONCEPT_SEARCH_FACETS = [
  SEARCH_FACETS.CONCEPT_FROM_QUERY,
  SEARCH_FACETS.BEST_TAGS,
  SEARCH_FACETS.RELATED_CONCEPTS,
];

export const SEARCH_FACET_TO_API_PARAMS = {
  [SEARCH_FACETS.BEST_TAGS]: 'refineconcepts',
  [SEARCH_FACETS.RELATED_CONCEPTS]: 'searchconcept',
  [SEARCH_FACETS.CONCEPT_FROM_QUERY]: 'refineconcepts',
};

export const SEARCH_EXCLUSIVE_FACETS = [
  SEARCH_FACETS.RELATED_CONCEPTS,
];

export const FACET_LOGICAL_OPERATION_MAP = {
  [SEARCH_FACETS.WHERE_MADE]: 'AND'
};

export const RECALL_FIELD_TO_API_SORT = {
  'product.name': 'product-name',
  'manufacturer.country': 'country-were-made',
  'countryName': 'country-were-recalled',
};

export const UI_FACETS_CONFIG = {
  [UI_FACET_CATEGORY]: {
    key: UI_FACET_CATEGORY,
    isTree: true,
    index: 0,
    intl: {
      title: 'category'
    },
  },
  [SEARCH_FACETS.WHERE_RECALLED]: {
    key: SEARCH_FACETS.WHERE_RECALLED,
    index: 1,
    intl: {
      title: 'where.recalled'
    },
  },
  [SEARCH_FACETS.WHERE_MADE]: {
    key: SEARCH_FACETS.WHERE_MADE,
    allowMultiple: true,
    index: 2,
    intl: {
      title: 'where.made'
    },
  },
  [SEARCH_FACETS.CONCEPT_FROM_QUERY]: {
    key: SEARCH_FACETS.CONCEPT_FROM_QUERY,
    isTree: true,
    allowMultiple: true,
    index: 3,
    intl: {
      title: 'filter.conceptFromQuery'
    },
  },
  [SEARCH_FACETS.BEST_TAGS]: {
    key: SEARCH_FACETS.BEST_TAGS,
    index: 4,
    intl: {
      title: 'filter.bestTags'
    },
  },
  [SEARCH_FACETS.RELATED_CONCEPTS]: {
    key: SEARCH_FACETS.RELATED_CONCEPTS,
    isTree: true,
    index: 5,
    intl: {
      title: 'filter.conceptRelated'
    },
  },
};

export const DEFAULT_LOCALE = 'en';

export const AVAILABLE_LOCALES = {
  en: { label: 'English' },
  fr: { label: 'Français' },
  ja: { label: '日本語' },
  es: { label: 'Español' },
  ko: { label: '한국어' },
};



// WEBPACK FOOTER //
// ./src/utils/constants.js